import { Controller } from '@hotwired/stimulus'

// Logo carousel controller - smooth infinite scrolling
export default class extends Controller {
  static targets = ['track', 'slide']

  connect() {
    this.scrollPosition = 0
    this.speed = 0.5 // pixels per frame
    this.isPaused = false

    // Wait for images to load to get accurate widths
    this.waitForImages().then(() => {
      this.setupDimensions()
      this.startAnimation()
    })

    // Pause on hover
    this.element.addEventListener('mouseenter', () => this.pause())
    this.element.addEventListener('mouseleave', () => this.resume())
  }

  disconnect() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  }

  waitForImages() {
    const images = this.element.querySelectorAll('img')
    const promises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve()
      return new Promise((resolve) => {
        img.addEventListener('load', resolve)
        img.addEventListener('error', resolve)
      })
    })
    return Promise.all(promises)
  }

  setupDimensions() {
    // Get the width of one complete set of logos
    if (this.hasSlideTarget) {
      this.slideWidth = this.slideTargets[0].offsetWidth
      // Add the gap between slides
      const gap = parseInt(getComputedStyle(this.trackTarget).gap, 10) || 48
      this.slideWidth += gap
    }
  }

  startAnimation() {
    const animate = () => {
      if (!this.isPaused) {
        this.scrollPosition += this.speed

        // Reset position when first set has scrolled out of view
        if (this.scrollPosition >= this.slideWidth) {
          this.scrollPosition = 0
        }

        this.trackTarget.style.transform = `translateX(-${this.scrollPosition}px)`
      }

      this.animationFrame = requestAnimationFrame(animate)
    }

    this.animationFrame = requestAnimationFrame(animate)
  }

  pause() {
    this.isPaused = true
  }

  resume() {
    this.isPaused = false
  }
}
